module.exports = __webpack_public_path__ + "static/media/greenBalloon.ebdc185e.svg";